import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '@environments/environment'
import { CrewMemberInfo } from '@events/models/crew-member.interface'
import { Observable, Subject } from 'rxjs'
import { tap } from 'rxjs/operators'

/**
 * Handles crew association to an event
 */
@Injectable({
  providedIn: 'root'
})
export class CrewService {
  /**
   * Creates the service and injects it's dependencies
   * @param http HttpClient
   */
  constructor(private http: HttpClient) {}

  /**
   * Subject that determines whether crew should be reloaded
   */
  public reloadCrewForEvent: Subject<void> = new Subject<void>()

  /**
   * Searches for a crew by his email address
   * @param term string
   * @returns Observable<CrewMemberInfo[]>
   */
  search(term: string): Observable<CrewMemberInfo[]> {
    return this.http.get<any>(`${environment.crewApi}users/search?term=${term}`)
  }

  /**
   * Invites a crew by his email address
   * @param term string
   * @param event event slug
   * @returns Observable
   */
  invite(term, event) {
    return this.http
      .post(`${environment.crewApi}events/invite`, {
        email: term.email ? term.email : term,
        event_id: event
      })
      .pipe(tap(() => this.reloadCrewForEvent.next()))
  }
  /**
   * Gets a list of crew assigned to an event
   * @param event event slug
   * @returns Observable
   */
  crew(event) {
    return this.http.get(`${environment.crewApi}events/assignees?event_id=${event}`)
  }

  /**
   * Unassigns a crew to an event
   * @param user user id
   * @param event event slug
   * @returns Observable
   */
  unassign(user, event) {
    return this.http
      .patch(`${environment.crewApi}events/unassign`, {
        user_id: user,
        event_id: event
      })
      .pipe(tap(() => this.reloadCrewForEvent.next()))
  }
}
